<template>
  <div>
    <div v-if="mobile" class="row no-gutters mx-3 mobile-button-row">
      <div class="col-4">
        <button @click="reject(id)" class="btn btn-danger btn-block reject-button h-100">
          <i class="fas fa-times fa-2x"></i>
        </button>
      </div>
      <div class="col-4">
        <div class="dropdown h-100">
          <button
            class="btn btn-secondary btn-block more-button h-100"
            id="dropdownMenuButton"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <i class="fas fa-ellipsis-h fa-2x"></i>
          </button>
          <div class="dropdown-menu dropdown-menu" aria-labelledby="dropdownMenuButton">
            <a v-if="instagram" class="dropdown-item" href="#" @click="accept(id, true, true)">
              <i class="fas fa-clock"></i> Urgent with Instagram
            </a>
            <a v-if="instagram" class="dropdown-item" href="#" @click="accept(id, true, false)">
              <i class="fas fa-clock"></i> Urgent without Instagram
            </a>
            <a v-else class="dropdown-item" href="#" @click="accept(id, true)">
              <i class="fas fa-clock"></i> Urgent
            </a>
            <a class="dropdown-item" href="#" @click="openEditModal(id)">
              <i class="fas fa-edit"></i> Edit
            </a>
            <a class="dropdown-item" href="#" @click="secondOpinion(id)">
              <i class="fas fa-gavel"></i> 2nd Opinion
            </a>
            <!-- @if($permissions->viewTruthDetails)
                <a class="dropdown-item" href="{{ route('pageAdmin.truth', [$page->url_prefix, $truth->id]) }}"><i class="fa fa-info-circle"></i> Details</a>
            @endif-->
            <a class="dropdown-item" :href="route_truth_details" v-if="route_truth_details">
              <i class="fa fa-info-circle"></i> Details
            </a>
            <a
              v-if="secondaryPages.length"
              class="dropdown-item"
              href="#"
              @click="openMoveModal(id)"
            >
              <i class="fas fa-truck-moving"></i> Move to other page
            </a>
            <a v-if="image_url" class="dropdown-item" href="#" @click="rotateImage(id, 270)">
              <i class="fas fa-redo"></i> Rotate CW
            </a>
            <a v-if="image_url" class="dropdown-item" href="#" @click="rotateImage(id, 90)">
              <i class="fas fa-undo"></i> Rotate CCW
            </a>
          </div>
        </div>
      </div>
      <div v-if="instagram" class="col-4">
          <button
            @click="accept(id)"
            id="post-approve-btn"
            class="btn btn-success btn-block accept-insta-button h-50 "
          >
            <i class="fas fa-check fa-2x"></i>
          </button>
          <div class="w-100"></div>
          <button
            @click="accept(id, false, true)"
            id="post-approve-btn"
            class="btn btn-primary btn-block accept-non-insta-button h-50"
          >
            <i class="fab fa-instagram fa-2x"></i>
          </button>
      </div>
      <div v-else class="col-4">
          <button
            @click="accept(id)"
            id="post-approve-btn"
            class="btn btn-success btn-block accept-button h-100 "
          >
            <i class="fas fa-check fa-2x"></i>
          </button>
      </div>
    </div>
    <div v-else class="row no-gutters">
      <div class="col-6">
        <button
          v-if="instagram"
          class="btn btn-info btn-block urgent-button submission-button"
          @click="accept(id, false, true)"
          v-tooltip:top.delay="'Accept & Post to Instagram'"
        >
          <i class="fab fa-instagram"></i>
        </button>
        <button
          v-if="instagram === false"
          class="btn btn-info btn-block urgent-button submission-button"
          @click="accept(id, true)"
          v-tooltip:top.delay="'Urgent'"
        >
          <i class="far fa-clock"></i>
        </button>
      </div>
      <div class="col-6">
        <button
          class="btn btn-success btn-block accept-button submission-button"
          @click="accept(id)"
          v-tooltip:top.delay="'Accept'"
        >
          <i class="fas fa-check"></i>
        </button>
      </div>
      <div class="w-100"></div>
      <div class="col-6">
        <div class="dropdown">
          <button
            class="btn btn-primary btn-block more-button submission-button"
            id="dropdownMenuButton"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <i class="fas fa-ellipsis-h"></i>
          </button>
          <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
            <button v-if="instagram" class="dropdown-item" @click="accept(id, true, true)">
              <i class="fas fa-clock"></i> Urgent with Instagram
            </button>
            <button v-if="instagram" class="dropdown-item" @click="accept(id, true, false)">
              <i class="fas fa-clock"></i> Urgent without Instagram
            </button>
            <button class="dropdown-item" @click="openEditModal(id)">
              <i class="fas fa-edit"></i> Edit
            </button>
            <button class="dropdown-item" @click="secondOpinion(id)">
              <i class="fas fa-gavel"></i> 2nd Opinion
            </button>
            <button
              v-if="secondaryPages.length"
              class="dropdown-item"
              @click="openMoveModal(id)"
            >
              <i class="fas fa-truck-moving"></i> Move to other page
            </button>
            <!-- Check permisions on this. -->
            <a class="dropdown-item" :href="route_truth_details" v-if="route_truth_details">
              <i class="fa fa-info-circle"></i> Details
            </a>
            <button v-if="image_url" class="dropdown-item" @click="rotateImage(id, 270)">
              <i class="fas fa-redo"></i> Rotate CW
            </button>
            <button v-if="image_url" class="dropdown-item" @click="rotateImage(id, 90)">
              <i class="fas fa-undo"></i> Rotate CCW
            </button>
          </div>
        </div>
      </div>
      <div class="col-6">
        <button
          class="btn btn-danger btn-block bg-utred border-utred reject-button submission-button"
          @click="reject(id)"
          v-tooltip:bottom.delay="'Reject'"
        >
          <i class="fas fa-times"></i>
        </button>
      </div>
    </div>
    <v-snackbar
        v-model="posting_queue_full_snackbar"
        :timeout="5000"
      >
        Your posting queue is full!
    </v-snackbar>
  </div>
</template>


<script>
export default {
  name: "SubButtons",

  data: () => ({
    posting_queue_full_snackbar: false,
  }),

  props: {
    id: {
      type: Number,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    image_url: {
      type: String
    },
    secondaryPages: {
      type: Array,
      default: () => []
    },
    route_truth_details: {
      type: String,
      required: true
    },
    mobile: {
      type: Boolean,
      default: false
    },
    instagram: {
      type: Boolean,
      default: null
    }
  },

  methods: {
    accept(id, urgent = false, withInstagram = false) {
      let self = this;
      axios
        .post("/api/queues/sorting/" + id + "/accept", {
          urgent: urgent,
          withInstagram: withInstagram
        })
        .then(function(response) {
          self.$emit("submission-dismissed", self);
        })
        .catch(function(error) {
          if (error?.response?.data?.message === "posting_queue_full") {
            self.posting_queue_full_snackbar = true;
          } else {
            console.log(error.type, error.message);
          }
        });
    },

    reject(id) {
      let self = this;
      axios
        .post("/api/queues/sorting/" + id + "/reject")
        .then(function(response) {
          self.$emit("submission-dismissed", self);
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    secondOpinion(id) {
      let self = this;
      axios
        .post("/api/queues/sorting/" + id + "/secondopinion")
        .then(function(response) {
          self.$emit("submission-dismissed", self);
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    openEditModal(id) {
      this.$emit("open-edit-modal", this.id, this.text);
    },

    openMoveModal(id) {
      this.$emit("open-move-modal", this.id);
    },

    rotateImage(id, counterClockwise) {
      let self = this;
      axios
        .post("/api/submissions/" + id + "/rotateimage", {
          counterClockwise: counterClockwise
        })
        .then(function(response) {
          // INCORRECT!! this should reload the submission!
          self.$emit("submission-dismissed", self);
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  }
};
</script>